<template>
    <div id="list-boiler-equipment-component" class="pa-4">
        <EmptyPageComponent
            :link_img="'/images/error/in_progress.png'"
            :main_text="$t('global.soon_available')"
            :secondary_text="$t('global.module_under_construction')"
            :show_secondary_text="true"
        />
    </div>
</template>

<script>
import EmptyPageComponent from '@/components/global/error/EmptyPageComponent.vue'

export default {
    name: 'ListBoilerEquipmentComponent',
    components: { EmptyPageComponent },
}
</script>
